import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { WorkTimeService } from '../services/work-time.service';
import { IWorkTime } from '../models/work-time';

@Injectable({
  providedIn: 'root'
})
export class EmployeeWorkTimeResolver  {
  constructor(private workTimeService: WorkTimeService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IWorkTime[]> {
    const id = route.paramMap.get("id");
    return this.workTimeService.searchWorkTimes({pageNumber:1, pageSize:999999, employeeId: id})
    .pipe(
      map(response => {
        return response.data;
      })
    );
  }
}
